import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AudittrayComponent } from "./component/audittray/audittray.component";


const routes: Routes = [
  {
    path: "",  component: AudittrayComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AudittrayRoutingModule {}
